/**
 * Client Hints MDX:
 * @see https://developer.mozilla.org/en-US/docs/Web/HTTP/Client_hints
 */
import React from "react";
import { getHintUtils } from "@epic-web/client-hints";
import {
  clientHint as colorSchemeHint,
  subscribeToSchemeChange,
} from "@epic-web/client-hints/color-scheme";
import { clientHint as timeZoneHint } from "@epic-web/client-hints/time-zone";
import { useRevalidator } from "react-router";

import { useOptionalRequestInfo, useRequestInfo } from "./request-info";

const hintsUtils = getHintUtils({
  theme: colorSchemeHint,
  timeZone: timeZoneHint,
});

export const { getHints } = hintsUtils;

export function ClientHintCheck({ nonce }: { nonce: string }) {
  // eslint-disable-next-line @typescript-eslint/unbound-method
  const { revalidate } = useRevalidator();
  React.useEffect(
    () => subscribeToSchemeChange(() => void revalidate()),
    [revalidate],
  );

  return (
    <script
      nonce={nonce}
      dangerouslySetInnerHTML={{
        __html: hintsUtils.getClientHintCheckScript(),
      }}
    />
  );
}

/**
 * @returns an object with the client hints and their values
 */
export function useHints() {
  const requestInfo = useRequestInfo();
  return requestInfo.hints;
}

export function useOptionalHints() {
  const requestInfo = useOptionalRequestInfo();
  return requestInfo?.hints;
}
